import { DoCheck, ChangeDetectorRef, Component, EventEmitter, forwardRef, Output, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { noop, VoidFn } from 'app/shared';
import { NotifyService } from 'app/notify';
import { AutocompleteModalComponent } from './autocomplete-modal/autocomplete-modal.component';
import { AutocompleteItem } from './autocomplete-item.model';

export const BATCH_CHECKBOX_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteComponent),
  multi: true
};

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [BATCH_CHECKBOX_VALUE_ACCESSOR]
})
export class AutocompleteComponent implements ControlValueAccessor, DoCheck  {

  @Input()
  public suggestions: any[] = [];
  @Input()
  public item: any = null;
  @Input()
  public editable: boolean = false;
  @Input()
  public optional: boolean = false;
  @Output()
  public onComplete: EventEmitter<any> = new EventEmitter();
  @Output()
  public onItemValidateChange: EventEmitter<any> = new EventEmitter();
  @Output()
  public onSubmitItem: EventEmitter<any> = new EventEmitter();
  @Output()
  public onSelectItem: EventEmitter<any> = new EventEmitter();

  public errorVisibility: boolean = false;

  private modelChanged: (value: Event) => void = noop;
  private modelTouched: VoidFn = noop;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private notify: NotifyService
  ) { }

  ngDoCheck() {
    this.changeDetector.detectChanges();
  }

  writeValue(value: any): void {
    this.suggestions = [value];
    this.changeDetector.markForCheck();
  }

  registerOnChange(fn): void {
    this.modelChanged = fn;
  }

  registerOnTouched(fn): void {
    this.modelTouched = fn;
  }

  public autocompleteOnChange(event: Event): void {
    this.modelChanged(event);
    this.onComplete.emit(event);
  }

  public onItemSelected(item: any): void {
    if (null === item.id) {
      this.displayItemModal();
    }

    this.setErrorVisibility();
    this.onSelectItem.emit({ item });
  }

  public displayItemModal(): void {
    this.notify.modal<AutocompleteModalComponent, any>(
      AutocompleteModalComponent,
      { item: this.item }
    )
    .subscribe(
      (responseItem: any) => {
        this.item.name = responseItem.name;
        this.onSubmitItem.emit({ item: new AutocompleteItem(this.item.id, responseItem.name) });
        this.errorVisibility = false;
      },
      () => {
        if (null === this.item.id) {
          this.errorVisibility = true;
        }
      }
    );
  }

  private changeItemValidate(): void {
    if (null === this.item || '' === this.item) {
      this.onItemValidateChange.emit(null);

      return;
    }

    this.onItemValidateChange.emit(this.item instanceof Object);
  }

  public isButtonDisabled(): boolean {
    this.changeItemValidate();

    return !(this.item instanceof Object);
  }

  public setErrorVisibility(): void {
    if (
      !this.optional ||
      this.item !== null
    ) {
      this.errorVisibility = !(this.item instanceof Object);
    }

  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/autocomplete/autocomplete.component.ts